/**
 * Consentimento de cookies (RGPD). Guardado no localStorage do visitante,
 * com data e versão do aviso mostrado. Nada de estatística/marketing corre
 * sem a categoria correspondente aceite.
 */
export const CONSENT_VERSION = "2026-10-26";
const KEY = "ic_consent";
const EVENT = "ic-consent-change";

export type Consent = {
  analytics: boolean;
  marketing: boolean;
  version: string;
  updatedAt: string;
};

export function readConsent(): Consent | null {
  if (typeof window === "undefined") return null;
  try {
    const raw = window.localStorage.getItem(KEY);
    if (!raw) return null;
    const c = JSON.parse(raw) as Consent;
    if (c.version !== CONSENT_VERSION) return null;
    return c;
  } catch {
    return null;
  }
}

export function saveConsent(analytics: boolean, marketing: boolean) {
  const c: Consent = { analytics, marketing, version: CONSENT_VERSION, updatedAt: new Date().toISOString() };
  window.localStorage.setItem(KEY, JSON.stringify(c));
  window.dispatchEvent(new CustomEvent(EVENT, { detail: c }));
  return c;
}

export function hasAnalytics() {
  return readConsent()?.analytics === true;
}
export function hasMarketing() {
  return readConsent()?.marketing === true;
}

/** Subscreve alterações (neste separador e noutros). */
export function onConsentChange(cb: (c: Consent | null) => void) {
  const local = () => cb(readConsent());
  const storage = (e: StorageEvent) => {
    if (e.key === KEY) cb(readConsent());
  };
  window.addEventListener(EVENT, local);
  window.addEventListener("storage", storage);
  return () => {
    window.removeEventListener(EVENT, local);
    window.removeEventListener("storage", storage);
  };
}

export const OPEN_SETTINGS_EVENT = "ic-open-cookie-settings";
export function openCookieSettings() {
  window.dispatchEvent(new Event(OPEN_SETTINGS_EVENT));
}
